module.exports = __webpack_public_path__ + "d5a3ae1c8a1ea3d1b04cb5d76da5b051.png";